/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Groups_Github_Auth_DescriptionInputs */

const en_admin_settings_groups_github_auth_description = /** @type {(inputs: Admin_Settings_Groups_Github_Auth_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub OAuth login`)
};

const zh_admin_settings_groups_github_auth_description = /** @type {(inputs: Admin_Settings_Groups_Github_Auth_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub OAuth 登录`)
};

/**
* | output |
* | --- |
* | "GitHub OAuth login" |
*
* @param {Admin_Settings_Groups_Github_Auth_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_settings_groups_github_auth_description = /** @type {((inputs?: Admin_Settings_Groups_Github_Auth_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Groups_Github_Auth_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_settings_groups_github_auth_description(inputs)
	return zh_admin_settings_groups_github_auth_description(inputs)
});
export { admin_settings_groups_github_auth_description as "admin.settings.groups.github_auth.description" }